import React, { useContext } from 'react';
import toast from 'react-hot-toast';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useSendActivities from '@src/hooks/useSendActivities';
import { ELeadSquaredActivityCode } from '@src/constants/leadsquaredActivityConstants';
import { GlobalStateContext } from '@src/context/GlobalContextProvider';

// "Schedule Call With Program Advisor" CTA at the bottom of the sidebar.
//
// Fires the same LeadSquared activity (PROGRAM_ADVISOR_SESSION) as
// CallBackModal.programAdvisorActivityHandler on the main program page so
// advisor team routing is identical. We don't reuse CallBackModal directly
// because that modal is a Crio-SAT-specific experience — we only want the
// activity dispatch + toast.
const AdvisorCtaFooter = ({ onCtaClick, isGlowing }) => {
  const { sendActivityHandler } = useSendActivities();
  const state = useContext(GlobalStateContext);

  const handleClick = () => {
    if (onCtaClick) onCtaClick();

    // Only fire the LSQ activity if we have a valid email address;
    // otherwise skip the call to avoid sending empty data to LeadSquared.
    const hasEmail = state?.email && state.email.trim() !== '';
    if (hasEmail) {
      sendActivityHandler(ELeadSquaredActivityCode.PROGRAM_ADVISOR_SESSION);
    }

    toast.success(
      'Our Program Advisor will reach out to you shortly to schedule a 1:1 with you.',
    );
  };

  return (
    <button
      type="button"
      onClick={handleClick}
      className={`flex w-full items-center justify-center gap-2 rounded-[10px] border-2 border-v5-yellow-200 bg-v5-yellow-200 py-4 px-6 font-manrope text-base font-bold text-black transition-all duration-500 hover:-translate-y-1 hover:shadow-xl hover:shadow-v5-yellow-300 ${
        isGlowing
          ? 'scale-105 shadow-[0_0_20px_rgba(253,224,71,0.8)]'
          : 'shadow-lg shadow-v5-yellow-200/50'
      }`}
    >
      Schedule Call With Program Advisor
      <FontAwesomeIcon icon={['fas', 'angle-right']} className="ml-1 text-lg" />
    </button>
  );
};

export default AdvisorCtaFooter;
